import React from 'react';
import { CircularProgress, styled } from '@material-ui/core';

const Wrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center'
});

const Loader = ({ size = 30 }) => {
  return (
    <Wrapper>
      <CircularProgress size={size} />
    </Wrapper>
  );
};

export default Loader;
